import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPin, Truck, Clock, Phone, CheckCircle, ArrowRight, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import Layout from '../components/layout/Layout';
import ProductCard from '../components/products/ProductCard';
import { companyInfo } from '../data/mock';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Данные городов для SEO
const citiesData = {
  tuymazy: {
    name: 'Туймазы',
    nameRod: 'Туймазов',
    namePredl: 'Туймазах',
    nameDat: 'Туймазы',
    region: 'Республика Башкортостан',
    distance: 0,
    deliveryTime: 'в день заказа',
    description: 'Туймазы — наш базовый город. Здесь расположено производство и склад готовой продукции. Доставка теплиц осуществляется в день заказа или на следующий день. Также доступен самовывоз со склада.',
    seoTitle: 'Теплицы из поликарбоната в Туймазах — купить от производителя',
    seoDescription: 'Купить теплицу из поликарбоната в Туймазах от производителя. Цены от 20 000 ₽. Доставка в день заказа. Гарантия 10 лет. Монтаж под ключ.',
    advantages: ['Самовывоз со склада', 'Доставка в день заказа', 'Монтаж в течение 2-4 часов', 'Консультация на складе'],
    nearbyAreas: ['Субханкулово', 'Нижнетроицкий', 'Кандры', 'Серафимовский']
  },
  belebey: {
    name: 'Белебей',
    nameRod: 'Белебея',
    namePredl: 'Белебее',
    nameDat: 'Белебей',
    region: 'Республика Башкортостан',
    distance: 45,
    deliveryTime: '1-2 дня',
    description: 'Доставка теплиц в Белебей осуществляется 2-3 раза в неделю. Наши теплицы уже установлены на сотнях участков в Белебее и Белебеевском районе. Возможен монтаж нашей бригадой.',
    seoTitle: 'Теплицы из поликарбоната в Белебее — доставка от производителя',
    seoDescription: 'Теплицы из поликарбоната с доставкой в Белебей. Цены от 20 000 ₽. Оцинкованный каркас, гарантия 10 лет.',
    advantages: ['Доставка 2-3 раза в неделю', 'Монтаж на участке', 'Более 100 установленных теплиц', 'Гарантийное обслуживание'],
    nearbyAreas: ['Приютово', 'Аксаково', 'Усень-Ивановское', 'Метевбаш']
  },
  oktyabrsky: {
    name: 'Октябрьский',
    nameRod: 'Октябрьского',
    namePredl: 'Октябрьском',
    nameDat: 'Октябрьский',
    region: 'Республика Башкортостан',
    distance: 35,
    deliveryTime: '1-2 дня',
    description: 'Октябрьский — один из крупнейших городов нашего региона доставки. Регулярные рейсы позволяют доставить теплицу быстро и недорого. Большой опыт установки теплиц в городских и дачных условиях.',
    seoTitle: 'Теплицы из поликарбоната в Октябрьском — недорого с доставкой',
    seoDescription: 'Купить теплицу в Октябрьском с доставкой. Теплицы из поликарбоната от производителя, цены от 20 000 ₽. Каркас оцинкованный.',
    advantages: ['Регулярная доставка', 'Большой выбор моделей', 'Установка на даче или в городе', 'Акции для жителей города'],
    nearbyAreas: ['Нарышево', 'Мулланур', 'Туймазинский район']
  },
  bavly: {
    name: 'Бавлы',
    nameRod: 'Бавлов',
    namePredl: 'Бавлах',
    nameDat: 'Бавлы',
    region: 'Республика Татарстан',
    distance: 60,
    deliveryTime: '2-3 дня',
    description: 'Доставляем теплицы в Бавлы и Бавлинский район Татарстана. Несмотря на расположение в соседней республике, регулярные рейсы позволяют обеспечить быструю доставку по выгодной цене.',
    seoTitle: 'Теплицы из поликарбоната в Бавлах — доставка из Башкортостана',
    seoDescription: 'Теплицы из поликарбоната с доставкой в Бавлы (Татарстан). От производителя из Башкортостана. Цены от 20 000 ₽, гарантия до 10 лет.',
    advantages: ['Доставка в Татарстан', 'Цены как в Башкортостане', 'Монтаж под ключ', 'Гарантия от производителя'],
    nearbyAreas: ['Ютазы', 'Бугульма', 'Азнакаево']
  },
  aznakaevo: {
    name: 'Азнакаево',
    nameRod: 'Азнакаево',
    namePredl: 'Азнакаево',
    nameDat: 'Азнакаево',
    region: 'Республика Татарстан',
    distance: 80,
    deliveryTime: '2-3 дня',
    description: 'Азнакаево и Азнакаевский район — территория нашей доставки в Татарстане. Теплицы с нашего производства отлично подходят для климата региона благодаря усиленным каркасам.',
    seoTitle: 'Теплицы в Азнакаево — купить из поликарбоната с доставкой',
    seoDescription: 'Теплицы из поликарбоната в Азнакаево с доставкой. Производитель из Башкортостана. Каркас 20x20, 25x25, 40x20. Гарантия 10 лет.',
    advantages: ['Усиленные каркасы для снежных зим', 'Доставка по Татарстану', 'Монтаж на участке', 'Консультация по выбору'],
    nearbyAreas: ['Актюбинский', 'Муслюмово', 'Альметьевск']
  },
  bugulma: {
    name: 'Бугульма',
    nameRod: 'Бугульмы',
    namePredl: 'Бугульме',
    nameDat: 'Бугульму',
    region: 'Республика Татарстан',
    distance: 100,
    deliveryTime: '2-4 дня',
    description: 'Бугульма — самый удалённый город нашей зоны доставки. Несмотря на расстояние, мы регулярно доставляем теплицы в Бугульму и Бугульминский район. Заказывайте заранее для планирования рейса.',
    seoTitle: 'Теплицы в Бугульме — из поликарбоната от производителя',
    seoDescription: 'Купить теплицу в Бугульме с доставкой. Теплицы из поликарбоната от производителя из Башкортостана. Гарантия, монтаж под ключ.',
    advantages: ['Доставка по графику', 'Теплицы для сурового климата', 'Комплексная установка', 'Запчасти и обслуживание'],
    nearbyAreas: ['Лениногорск', 'Альметьевск', 'Заинск']
  }
};

const CityDeliveryPage = () => {
  const { city } = useParams();
  const cityData = citiesData[city];
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${API_URL}/api/products`);
        if (response.ok) {
          const data = await response.json();
          // Показываем хиты продаж
          setProducts(data.filter(p => p.isHit || p.isNew).slice(0, 4));
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  if (!cityData) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Город не найден</h1>
          <p className="text-gray-600 mb-6">К сожалению, мы пока не доставляем в этот город.</p>
          <Link to="/delivery">
            <Button>Все города доставки</Button>
          </Link>
        </div>
      </Layout>
    );
  }

  // Другие города для блока "Доставка в другие города"
  const otherCities = Object.entries(citiesData)
    .filter(([key]) => key !== city)
    .slice(0, 4);

  return (
    <Layout>
      {/* SEO Helmet */}
      <Helmet>
        <title>{cityData.seoTitle}</title>
        <meta name="description" content={cityData.seoDescription} />
        <meta name="keywords" content={`теплицы ${cityData.name}, купить теплицу ${cityData.name}, теплицы из поликарбоната ${cityData.name}, доставка теплиц ${cityData.name}`} />
        <link rel="canonical" href={`https://теплицынадом.рф/dostavka/${city}`} />
        
        {/* Schema.org для страницы доставки */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "DeliveryService",
            "name": `Доставка теплиц в ${cityData.name}`,
            "provider": {
              "@type": "LocalBusiness",
              "name": "Народные теплицы"
            },
            "areaServed": {
              "@type": "City",
              "name": cityData.name,
              "addressRegion": cityData.region
            },
            "deliveryTime": cityData.deliveryTime
          })}
        </script>
      </Helmet>

      {/* Breadcrumbs */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-emerald-600">Главная</Link>
            <ChevronRight className="w-4 h-4" />
            <Link to="/delivery" className="hover:text-emerald-600">Доставка</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-gray-900">{cityData.name}</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-emerald-50 to-green-50 py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl">
            <Badge className="bg-emerald-100 text-emerald-700 mb-4">
              <MapPin className="w-3 h-3 mr-1" />
              {cityData.region}
            </Badge>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Теплицы из поликарбоната в {cityData.namePredl}
            </h1>
            
            <p className="text-lg text-gray-600 mb-8">
              {cityData.description}
            </p>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <Clock className="w-6 h-6 text-emerald-600 mb-2" />
                <p className="text-sm text-gray-500">Срок доставки</p>
                <p className="font-bold text-gray-900">{cityData.deliveryTime}</p>
              </div>
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <MapPin className="w-6 h-6 text-emerald-600 mb-2" />
                <p className="text-sm text-gray-500">Расстояние</p>
                <p className="font-bold text-gray-900">{cityData.distance} км</p>
              </div>
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <Phone className="w-6 h-6 text-emerald-600 mb-2" />
                <p className="text-sm text-gray-500">Телефон</p>
                <p className="font-bold text-gray-900">{companyInfo.phone}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/catalog">
                <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700">
                  Выбрать теплицу
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
              <a href={`tel:${companyInfo.phoneClean}`}>
                <Button size="lg" variant="outline" className="border-emerald-600 text-emerald-700">
                  <Phone className="w-5 h-5 mr-2" />
                  Позвонить
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            Преимущества доставки в {cityData.nameDat || cityData.name}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {cityData.advantages.map((advantage, index) => (
              <div key={index} className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" />
                <p className="text-gray-700">{advantage}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Products */}
      {products.length > 0 && (
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Популярные теплицы с доставкой в {cityData.nameDat || cityData.name}
            </h2>
            <p className="text-gray-600 mb-8">
              Эти модели чаще всего заказывают жители {cityData.nameRod}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
            <div className="text-center mt-8">
              <Link to="/catalog">
                <Button variant="outline" className="border-emerald-600 text-emerald-600">
                  Смотреть весь каталог
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Nearby Areas */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Также доставляем в районы {cityData.nameRod}
          </h2>
          <div className="flex flex-wrap gap-3">
            {cityData.nearbyAreas.map((area, index) => (
              <Badge key={index} variant="outline" className="text-gray-600 border-gray-300 px-4 py-2">
                {area}
              </Badge>
            ))}
          </div>
        </div>
      </section>

      {/* Other Cities */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            Доставка в другие города
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {otherCities.map(([key, data]) => (
              <Link
                key={key}
                to={`/dostavka/${key}`}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
              >
                <h3 className="font-semibold text-gray-900 mb-2">{data.name}</h3>
                <p className="text-sm text-gray-500">{data.region}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 bg-emerald-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Закажите теплицу с доставкой в {cityData.name}
          </h2>
          <p className="text-emerald-100 mb-8 max-w-2xl mx-auto">
            Позвоните нам или оставьте заявку на сайте. Мы поможем выбрать теплицу и организуем доставку.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href={`tel:${companyInfo.phoneClean}`}>
              <Button size="lg" variant="secondary" className="bg-white text-emerald-600 hover:bg-gray-100">
                <Phone className="w-5 h-5 mr-2" />
                {companyInfo.phone}
              </Button>
            </a>
            <Link to="/catalog">
              <Button size="lg" className="bg-emerald-700 hover:bg-emerald-800 text-white">
                Выбрать теплицу
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CityDeliveryPage;
